var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Page, PageTitle } from '@styled/Page';
import { appColors } from '@styled/useTheme';
import React from 'react';
import { FaCog } from 'react-icons/fa';
var GROW_PLS = { display: 'flex', flexGrow: 1, maxHeight: '100%', flexDirection: 'column' };
var LEFT_STYLE = __assign(__assign({}, GROW_PLS), { flex: 1, marginRight: 15 });
var RIGHT_STYLE = __assign(__assign({}, GROW_PLS), { flex: 4, marginLeft: 15 });
function ManagerLayout(_a) {
    var title = _a.title, contentLeft = _a.contentLeft, contentRight = _a.contentRight;
    var left = contentLeft instanceof Function ? contentLeft(LEFT_STYLE) : React.createElement("div", { style: LEFT_STYLE }, contentLeft);
    var right = contentRight instanceof Function ? contentRight(RIGHT_STYLE) : React.createElement("div", { style: RIGHT_STYLE }, contentRight);
    return (React.createElement(Page, null,
        React.createElement(PageTitle, null,
            React.createElement(FaCog, { style: { color: appColors.primary.w500 } }),
            React.createElement("h2", null, title)),
        React.createElement("div", { style: { display: 'flex', flexGrow: 1, minHeight: 0 } },
            left,
            right)));
}
export default ManagerLayout;
